"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseQuestion = _interopRequireDefault(require("./BaseQuestion"));
var _QuestionFactory = require("./QuestionFactory");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class MultiQuestion extends _BaseQuestion.default {
  updateMetaData() {
    this.selections.forEach((selection, index) => {
      const multiItem = this.question.multi[index];
      const currentQuestion = (0, _QuestionFactory.createQuestion)(multiItem.type, {
        question: {
          ...multiItem,
          enable: [...(multiItem.enable || []), ...(this.question.enable || [])]
        },
        selections: [selection],
        metadata: this.metadata
      });
      currentQuestion.updateMetaData();
    });
    return this.metadata;
  }
}
exports.default = MultiQuestion;